module.exports = __webpack_public_path__ + "8cc60d669d43212b42a057b2ab74d4b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2075_teaser_image.jpg
// module id = 586
// module chunks = 0